export enum Operation {
  Deposit = "Deposit",
  Withdrawal = "Withdrawal",
  Shift = "Shift",
}

export enum Mode {
  Single = "Single",
  Pair = "Pair",
}
